import * as type from '../actions/types';

const initialState = {
  sending: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.HELP_DEAL_PENDING:
      return {
        ...state,
        sending: true,
        error: false,
        errorMessage: '',
      };
    case type.HELP_DEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        success: true,
      };
    case type.HELP_DEAL_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        sending: false,
      };

    case type.CLEAR_HELP_DEAL:
      return {
        ...state,
        sending: false,
        error: false,
        errorMessage: '',
        success: false,
      };

    default:
      return state;
  }
};
